// Formatação de timestamps vindos da API do SantoLog.
//
// IMPORTANTE (timezone): os datetimes chegam com "Z" mas já são o horário LOCAL
// correto. NÃO converter de UTC (nada de new Date(...).toLocaleString, que
// deslocaria ±3h). Extraímos os componentes literais por regex.

function parseApiLocalParts(ts) {
  if (!ts) return null
  const m = String(ts).match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/)
  if (!m) return null
  const [, y, mo, d, h, mi, s] = m
  return { y, mo, d, h, mi, s: s || '00' }
}

/** "DD/MM/AAAA HH:mm" — sem conversão de timezone. Vazio → "—". */
export function formatBeep(ts) {
  const p = parseApiLocalParts(ts)
  if (!p) return '—'
  return `${p.d}/${p.mo}/${p.y} ${p.h}:${p.mi}`
}

/** "DD/MM HH:mm" — versão curta para metadados densos. Vazio → "—". */
export function formatBeepShort(ts) {
  const p = parseApiLocalParts(ts)
  if (!p) return '—'
  return `${p.d}/${p.mo} ${p.h}:${p.mi}`
}
